import * as types from "./type.js";
export default {
  [types.MODULE_ID]: 0,
  courseId: 0,
  quizId: 0,
  groupId: 0,
  instantId: 0,
  galleryid: 0,
  code: "",
  projection: {
    mode: "",
    fileurl: "",
    filename: "",
    show: false
  },
  imagePreview: {
    files: [],
    show: false,
    mode: "image"
  },
  mobileInfo: {
    width: 375,
    height: 667
  },
  pptInfo: {
    show: false,
    nowPage: 0,
    galleryid: 0,
    files: []
  },
  curPage: 0,
  // 学生举手
  raiseHandStudents: [],
  // 学生上线
  studentsOnlines: [],
  // 教师是否在线
  isTeacherOnline: false
};
